import * as React from 'react';
import { useMemo } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';

import { Ifacility, IinstallBase, Ipart, IsuggestedPartPopulated } from '../../models';
import { IinitialState } from '../../reducers';
import { selectSuggestedPartsForTable } from '../../reducers/partsReducer';
import { Banner } from '../common/Banner';
import { constants } from '../../constants/constants';
import { WithTranslation, withTranslation } from 'react-i18next';
import { initialFacility } from '../../reducers/initialState';
import { TableUtil } from '../common/TableUtil';
import { useTable, Column } from 'react-table';
import { TFunction } from 'i18next';
import { SearchAllPartsModalandContainer } from './SearchAllPartsModalandContainer';
import { addQuery } from '../common/OtherUtils';
import queryString from 'query-string';
import { LinkContainer } from 'react-router-bootstrap';
import { addPartToCart } from '../../actions/partsActions';
import { partTypeEnum } from '../../models-enums';
import { SearchAllPartsForm } from '../manageJob/SearchAllPartsForm';
import { selectIsLoading } from '../../reducers/commonReducers';

export enum suggestedPartsQueryParamsEnum {
    showSearchPartsModal = 'showSearchPartsModal'
}

const buildColumns = (t: TFunction) => {
    return TableUtil.translateHeaders(
        [
            {
                Header: 'part',
                id: 'part',
                accessor: ({ part }: IsuggestedPartPopulated) => `${part.number} - ${part.description}`,
                minWidth: 200
            },
            {
                Header: 'product',
                accessor: 'productName',
                minWidth: 200
            },
            {
                Header: 'times used',
                accessor: 'productQuantity',
                width: 150
            },
            {
                Header: 'comments',
                accessor: 'adminComments',
                minWidth: 200
            },
            {
                Header: 'service time',
                accessor: ({ part }: IsuggestedPartPopulated) => part.installationTime,
                width: 150
            }
        ],
        t
    ) as Column<IsuggestedPartPopulated>[];
};

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Iprops extends RouteComponentProps<{ installID: string }> {
    // t: TFunction;
}

interface IdispatchProps {
    installBase: IinstallBase | undefined;
    facilityID: string;
    facility: Ifacility;
    productName: string;
    tableData: IsuggestedPartPopulated[];
    queryParams: typeof suggestedPartsQueryParamsEnum;
    addPartToCart: typeof addPartToCart;
    loading: boolean;
}

const SuggestedPartsLayout = (props: Iprops & IdispatchProps & WithTranslation) => {
    const { t, facility, installBase, productName, tableData, loading } = props;

    const colorButton = constants.colors[`blueButton`];

    const bannerTitle = t('bannerTitleMobile');

    const handleAdd = (original: IsuggestedPartPopulated) => {
        if (!installBase) {
            console.error('installBase is undefined. Unable to add part to cart.');
            return;
        }
        props.addPartToCart(original.part, installBase.id);
    };

    const handleSearchAllAdd = (part: Ipart) => {
        if (!installBase) {
            console.error('installBase is undefined. Unable to add part to cart.');
            return;
        }
        props.addPartToCart(part, installBase.id);
    };

    const handleLaborAdd = (part: Ipart) => {
        props.addPartToCart(part);
    };

    // Build columns using useMemo for performance
    const columns = useMemo(() => buildColumns(t), [t]);

    // Use react-table v7 hooks
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable<IsuggestedPartPopulated>({
        columns,
        data: tableData
    });

    /*
     * Handle user clicking on a location row
     * set the selected location to state and open the modal
     */
    const getTrProps = (rowInfo: any) => {
        if (rowInfo) {
            return {
                onClick: () => {
                    handleAdd(rowInfo.original);
                }
            };
        } else {
            return {};
        }
    };

    // Early return if installBase is undefined
    if (!installBase) {
        return <div>Loading...</div>;
    }

    return (
        <div className="suggested-parts">
            <Row>
                <Banner
                    title=""
                    img=""
                    color={constants.colors[`blue`]}
                    subtitle={productName}
                    subsubtitle={TableUtil.buildLocation(installBase, facility)}
                />
            </Row>
            <Row>
                <Col
                    style={{
                        flexGrow: 1,
                        fontSize: '2rem',
                        marginLeft: '48px',
                        padding: '24px 0'
                    }}
                >
                    {bannerTitle}
                </Col>
            </Row>
            <Row style={{ display: 'flex' }}>
                <Col xs={6} style={{ marginLeft: '15px' }}>
                    <SearchAllPartsForm
                        partType={partTypeEnum.labor}
                        colorButton={colorButton}
                        onSubmit={handleLaborAdd}
                        t={t}
                        loading={loading}
                    />
                </Col>
                <Col style={{ margin: '25px 38px 15px 30px' }}>
                    <Button
                        onClick={() => {
                            addQuery(suggestedPartsQueryParamsEnum.showSearchPartsModal, 'true', props.history);
                        }}
                        style={{ marginRight: '28px' }}
                    >
                        Search All Parts
                    </Button>
                    <LinkContainer to={`/devices/${installBase.id}`}>
                        <Button>Back</Button>
                    </LinkContainer>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <h4
                        style={{
                            flexGrow: 1,
                            fontSize: '1.4rem',
                            marginLeft: '30px',
                            padding: '10px 0'
                        }}
                    >
                        {t('suggestedPartsMobileSubTitle')}
                    </h4>
                    <table {...getTableProps()} className={`beacon-table -highlight blue`}>
                        <thead>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.getHeaderGroupProps().key}>
                                    {headerGroup.headers.map(column => (
                                        <th {...column.getHeaderProps()} key={column.getHeaderProps().key}>
                                            {column.render('Header')}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {rows.map((row, i) => {
                                prepareRow(row);
                                const rowProps = getTrProps({ index: i, original: row.original });
                                return (
                                    <tr {...row.getRowProps()} key={row.getRowProps().key} onClick={rowProps.onClick}>
                                        {row.cells.map(cell => {
                                            return (
                                                <td {...cell.getCellProps()} key={cell.getCellProps().key}>
                                                    {cell.render('Cell')}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    {tableData.length === 0 && (
                        <div style={{ textAlign: 'center', padding: '20px' }}>{String(t('common:noDataText'))}</div>
                    )}
                </Col>
            </Row>
            <SearchAllPartsModalandContainer
                colorButton={colorButton}
                onSubmit={handleSearchAllAdd}
                partType={partTypeEnum.default}
                shouldShowQuantity={true}
            />
        </div>
    );
};

const makeMapStateToProps = () => {
    return (state: IinitialState, ownProps: Iprops) => {
        const installID = ownProps.match.params.installID;
        const installBase = state.manageInventory.installBasesByID[installID];
        if (!installBase) {
            return {
                installBase: undefined,
                facilityID: '',
                facility: initialFacility,
                productName: '',
                tableData: [],
                queryParams: {},
                loading: selectIsLoading(state)
            };
        }
        const facilityID = installBase.facilityID || '';
        const facility = state.facilities.facilitiesByID[facilityID] || initialFacility;
        const productName = state.manageInventory.productsByID[installBase.materialID]?.name || '';
        const tableData = selectSuggestedPartsForTable(state, { installBase });
        const queryParams = queryString.parse(ownProps.location.search);

        return {
            installBase,
            facilityID,
            facility,
            productName,
            tableData,
            queryParams,
            loading: selectIsLoading(state)
        };
    };
};

export default withTranslation('nsPart')(
    connect(makeMapStateToProps(), {
        addPartToCart
    })(SuggestedPartsLayout)
);
